module.exports = __webpack_public_path__ + "components/profile/static/icon-caret-right-d8e60f359204b0b66a5ff6feb291984f.svg";